module.exports = __webpack_public_path__ + "static/media/InvolvedXs1.fbb5ad3b.svg";